import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GestiuneAjutoareService {
    private base = environment.interop.basePath + 'api/cerere/ajutoare/gestiune/';
    private pvBase = environment.interop.basePath + 'api/cerere/ajutoare/pre-validare/';

    constructor(private http: HttpClient) {}

    // ── Pre-validare ──

    getPreValidareStats(): Observable<any> { return this.http.get(this.pvBase + 'stats'); }
    getUsersCompartiment(compId: number): Observable<any> { return this.http.get(this.pvBase + 'users-compartiment/' + compId); }
    getPreValidare(cerereId: number): Observable<any> { return this.http.get(this.pvBase + cerereId); }

    repartizeazaResponsabil(cerereId: number, data: any): Observable<any> { return this.http.post(this.pvBase + cerereId + '/repartizeaza', data); }
    aprobaPas1(cerereId: number, data?: any): Observable<any> { return this.http.post(this.pvBase + cerereId + '/pas1/aproba', data || {}); }
    respingePas1(cerereId: number, data: any): Observable<any> { return this.http.post(this.pvBase + cerereId + '/pas1/respinge', data); }

    alocaAnaf(cerereId: number, data: any): Observable<any> { return this.http.post(this.pvBase + cerereId + '/pas2/aloca-anaf', data); }
    uploadDocAnaf(cerereId: number, data: any): Observable<any> { return this.http.post(this.pvBase + cerereId + '/pas2/upload-doc', data); }
    deleteDocAnaf(cerereId: number, docId: number): Observable<any> { return this.http.delete(this.pvBase + cerereId + '/pas2/doc/' + docId); }
    completeazaPas2(cerereId: number, data?: any): Observable<any> { return this.http.post(this.pvBase + cerereId + '/pas2/completeaza', data || {}); }

    uploadAnexa(cerereId: number, data: any): Observable<any> { return this.http.post(this.pvBase + cerereId + '/anexe/upload', data); }
    replaceAnexa(cerereId: number, docId: number, data: any): Observable<any> { return this.http.post(this.pvBase + cerereId + '/anexe/' + docId + '/replace', data); }
    deleteAnexa(cerereId: number, docId: number): Observable<any> { return this.http.delete(this.pvBase + cerereId + '/anexe/' + docId); }

    massAssignVerificareVenituri(data: any): Observable<any> { return this.http.post(this.pvBase + 'mass-assign-verificare-venituri', data); }
    getMyCounters(): Observable<any> { return this.http.post(this.pvBase + 'my-counters', {}); }
    getOperatorsWorkload(): Observable<any> { return this.http.get(this.pvBase + 'operators-workload'); }
    saveFisaFields(cerereId: number, data: any): Observable<any> { return this.http.post(this.pvBase + cerereId + '/fisa/save-fields', data); }
    getFisaWordUrl(cerereId: number): string { return this.pvBase + cerereId + '/fisa/generate-word'; }
    uploadFisaSemnata(cerereId: number, data: any): Observable<any> { return this.http.post(this.pvBase + cerereId + '/fisa/upload-signed', data); }

    getEtape(params: any): Observable<any> {
        return this.http.get(this.base + 'etape', { params });
    }

    getEligibleEtapeIds(params: any): Observable<any> {
        return this.http.get(this.base + 'etape/eligible-ids', { params });
    }

    getLoturi(params: any): Observable<any> {
        return this.http.get(this.base + 'loturi', { params });
    }

    getLotDetail(lotId: number): Observable<any> {
        return this.http.get(this.base + 'lot/' + lotId);
    }

    createLot(data: { etapa_ids: number[]; dispozitie_nr: string; dispozitie_data: string }): Observable<any> {
        return this.http.post(this.base + 'lot/create', data);
    }

    confirmLot(lotId: number, sumaPerCerere?: number): Observable<any> {
        return this.http.post(this.base + 'lot/' + lotId + '/confirm', { suma_per_cerere: sumaPerCerere });
    }

    getDashboard(params?: any): Observable<any> {
        return this.http.get(this.base + 'dashboard', { params });
    }

    getExportEtapeUrl(params: any): string {
        const qs = Object.entries(params).filter(([, v]) => v).map(([k, v]) => `${k}=${v}`).join('&');
        return this.base + 'export/etape' + (qs ? '?' + qs : '');
    }

    getExportLotUrl(lotId: number): string {
        return this.base + 'export/lot/' + lotId;
    }

    // Loturi Invalidare
    getCereriInvalidate(params: any): Observable<any> {
        return this.http.get(this.base + 'cereri-invalidate', { params });
    }

    createLotInvalidare(data: { cerere_ids: number[]; dispozitie_nr: string; dispozitie_data: string }): Observable<any> {
        return this.http.post(this.base + 'lot-invalidare', data);
    }

    getLoturiInvalidare(params: any): Observable<any> {
        return this.http.get(this.base + 'loturi-invalidare', { params });
    }

    getLotInvalidareDetail(lotId: number): Observable<any> {
        return this.http.get(this.base + 'lot-invalidare/' + lotId);
    }

    confirmLotInvalidare(lotId: number): Observable<any> {
        return this.http.post(this.base + 'lot-invalidare/' + lotId + '/confirm', {});
    }

    // Preview (JSON paginat)
    previewInvalidari(params: any): Observable<any> {
        return this.http.get(this.base + 'preview/invalidari', { params });
    }

    previewOP(params: any): Observable<any> {
        return this.http.get(this.base + 'preview/op', { params });
    }

    previewSituatie(params: any): Observable<any> {
        return this.http.get(this.base + 'preview/situatie', { params });
    }

    // Rapoarte Excel
    getExportInvalidariUrl(params: any): string {
        const qs = Object.entries(params).filter(([, v]) => v).map(([k, v]) => `${k}=${v}`).join('&');
        return this.base + 'export/invalidari' + (qs ? '?' + qs : '');
    }

    getExportOPUrl(params: any): string {
        const qs = Object.entries(params).filter(([, v]) => v).map(([k, v]) => `${k}=${v}`).join('&');
        return this.base + 'export/op' + (qs ? '?' + qs : '');
    }

    getExportSituatieUrl(params: any): string {
        const qs = Object.entries(params).filter(([, v]) => v).map(([k, v]) => `${k}=${v}`).join('&');
        return this.base + 'export/situatie' + (qs ? '?' + qs : '');
    }
}
